import { render } from "./ModalForm.vue?vue&type=template&id=59da7f8a"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"
script.render = render

export default script